/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../axios-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../axios-client";
import type { GetApiBarberShiftsAvailableSlotsQueryResponse, GetApiBarberShiftsAvailableSlotsQueryParams, GetApiBarberShiftsAvailableSlots400, GetApiBarberShiftsAvailableSlots401, GetApiBarberShiftsAvailableSlots403, GetApiBarberShiftsAvailableSlots404, GetApiBarberShiftsAvailableSlots500 } from "../entities/GetApiBarberShiftsAvailableSlots";

function getGetApiBarberShiftsAvailableSlotsUrl() {
  const res = { method: 'GET', url: `/api/barber/shifts/available-slots` as const }
  return res
}

/**
 * @description Получить доступные слоты и занятые интервалы кресел для бронирования смены за период
 * @summary Доступные слоты смен
 * {@link /api/barber/shifts/available-slots}
 */
export async function getApiBarberShiftsAvailableSlots(params: GetApiBarberShiftsAvailableSlotsQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<GetApiBarberShiftsAvailableSlotsQueryResponse, ResponseErrorConfig<GetApiBarberShiftsAvailableSlots400 | GetApiBarberShiftsAvailableSlots401 | GetApiBarberShiftsAvailableSlots403 | GetApiBarberShiftsAvailableSlots404 | GetApiBarberShiftsAvailableSlots500>, unknown>({ method : "GET", url : getGetApiBarberShiftsAvailableSlotsUrl().url.toString(), params, ... requestConfig })
  return res.data
}